<div class="Demo">
  <icullen-subscription-info [partialAuth]="partialAuth" [accessType]="data.accessType"></icullen-subscription-info>
  <!-- DOC INFOS -->
 <document-mini-info [data]="data"></document-mini-info>
</div>
 <!-- PAYWALL COMPONENT -->
 <document-paywall
  *ngIf="!hasFullAccess()"
  [subscriptionInfo]="getSusbscriptionInfo()"
 >
</document-paywall>
